import { render } from "./AppBar.vue?vue&type=template&id=f63ad348&ts=true"
import script from "./AppBar.vue?vue&type=script&lang=ts"
export * from "./AppBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__